'use client';

import MobileNavigation from '@components/header/components/navigation/mobile-navigation-list.view';
import NavigationList from '@components/header/components/navigation/navigaton-list.view';
import type { ReactElement } from 'react';
import React from 'react';
import type { NavigationLink } from 'types/navigation-link';
import { validateString } from 'utils/validate-string';

import styles from './navigation.module.scss';

interface Props {
  readonly links: NavigationLink[];
}

const navigationRootClass = validateString(styles.navigationMenuRoot);

function Navigation({ links }: Props): ReactElement {
  return (
    <div className={navigationRootClass}>
      <NavigationList links={links} />

      <MobileNavigation links={links} />
    </div>
  );
}

export default Navigation;
